export default function required(val) {
  const normalizedValue = typeof val !== 'string' ? val?.toString() : val
  return {
    error: !normalizedValue.trim(),
    errorMessage: 'can\'t be blank'
  }
}
